import FolderSharedIcon from '@mui/icons-material/FolderShared';
import { FormattedMessage } from 'react-intl';
import { IDevice } from '../../../modules/devices/store/deviceStore';
import RowMenuItem from '../../DataGrid/RowMenuItem';
import messages from '../messages';

interface ISetApartmentProps {
  device: IDevice;
  disabled: boolean;
  onOpenSetApartmentModal: (device: IDevice) => void;
}

const SetApartment = ({ device, disabled, onOpenSetApartmentModal }: ISetApartmentProps) => (
  <RowMenuItem
    disabled={disabled}
    icon={<FolderSharedIcon />}
    label={<FormattedMessage {...messages.deviceDataGridActionDeviceRowMenuSetApartment} />}
    onClick={() => onOpenSetApartmentModal(device)}
  />
);

export default SetApartment;
